/* src/app/service-item/service-item-container/service-item-container.component.scss */
body#themeTag :host ::ng-deep {
  line-height: 1.5rem !important;
}
/*# sourceMappingURL=service-item-container.component.css.map */
